import { Controller } from 'stimulus';

// Fills the hourly rate from the picked timed service and locks it, as the header tracker does in
// assets/js/shared/tracker-widget.js. A non-billable service has no rate, so its row is hidden.
export default class extends Controller {
  static targets = ['rate', 'rateRow'];
  static values = { services: Object };

  pick({ detail: { value } }) {
    if (!this.hasRateTarget) {
      return;
    }

    const service = this.servicesValue[value];
    const nonBillable = Boolean(service?.nonBillable);
    this.rateTarget.value = service && !nonBillable ? service.rate : '';
    this.rateTarget.readOnly = Boolean(service);
    this.rateRowTarget.hidden = nonBillable;
  }
}
